import { i18n } from 'boot/i18n';

/**
 * A row's menu: View activity first, then Fix. Fix is offered only when this user may open that
 * record's editor, because a Fix that opens onto a refusal is worse than none.
 *
 * @param {{sessionActivityId: string|null, fix: Object|null}} row
 * @param {import('../../application/ports/FixSurfaces.port').FixSurfaces|null} fixSurfaces
 * @returns {{label: string, icon: string, action: Function}[]}
 */
// eslint-disable-next-line import/prefer-default-export
export function billingItemRowActions(row, fixSurfaces) {
  if (!fixSurfaces) {
    return [];
  }
  const actions = [];

  if (row.sessionActivityId) {
    actions.push({
      label: i18n.t('billingItems.actionViewActivity'),
      icon: 'visibility',
      action: () => fixSurfaces.openActivity(row.sessionActivityId),
    });
  }
  if (row.fix && fixSurfaces.canFix(row.fix)) {
    actions.push({
      label: i18n.t('billingItems.actionFix'),
      icon: 'build',
      action: () => fixSurfaces.openFix(row.fix),
    });
  }

  return actions;
} // billingItemRowActions()
